"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _chunk = _interopRequireDefault(require("lodash/chunk"));
var _dateHelper = require("../../../helpers/dateHelper");
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _kycConfigShapePropTypes = require("../../../propTypes/kycConfigShapePropTypes");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./KYCConfirmLevelModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var classes = (0, _cssClassesHelper.getBEMClasses)('kyc-confirm-level');
var KYCConfirmLevelModal = /*#__PURE__*/function (_React$Component) {
  function KYCConfirmLevelModal() {
    var _this;
    _classCallCheck(this, KYCConfirmLevelModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, KYCConfirmLevelModal, [].concat(args));
    _defineProperty(_this, "renderImage", function (image, field) {
      return !image ? null : /*#__PURE__*/_react["default"].createElement("img", {
        className: classes('section-field-value-img'),
        src: image.imgSrc,
        alt: field.name
      });
    });
    _defineProperty(_this, "renderUpload", function (value) {
      return !value ? null : value.file && value.file.name;
    });
    _defineProperty(_this, "renderValue", function (values, field) {
      var isSimpleValue = !['date', 'image', 'upload', 'document'].includes(field.type);
      var renderMethods = {
        date: function date(_date) {
          return (0, _dateHelper.formatDate)(_date);
        },
        image: _this.renderImage,
        upload: _this.renderUpload,
        document: _this.renderUpload
      };
      var value = values[field.name];
      var renderValue = renderMethods[field.type];
      return isSimpleValue ? value : renderValue(value, field);
    });
    return _this;
  }
  _inherits(KYCConfirmLevelModal, _React$Component);
  return _createClass(KYCConfirmLevelModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var _this$props = this.props,
        level = _this$props.level,
        values = _this$props.values,
        processing = _this$props.processing,
        _close = _this$props.close,
        onConfirm = _this$props.onConfirm,
        isOpen = _this$props.isOpen;
      var sectionGroups = level ? (0, _chunk["default"])(level.sections, 2) : [];
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        customClass: classes(),
        isOpen: isOpen,
        title: t("Confirm Increase Verification Level Application"),
        close: function close() {
          return _close();
        },
        footer: {
          buttonText: processing ? t("Processing...") : t("Confirm"),
          disabled: processing,
          onClick: onConfirm,
          overrideClose: true,
          buttonStyle: 'success'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes('body')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes('description')
      }, t("Thanks for applying to increase your Verification Level. Once we have approved your application, you will next be required to submit identification documentation.")), sectionGroups.map(function (sections, idx) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: idx,
          className: classes('sections-wrapper')
        }, sections.map(function (section, idx) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: section.label + idx,
            className: classes('section')
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: classes('section-header')
          }, t(section.label)), section && section.form.map(function (field, idx) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: field.name + idx,
              className: classes('section-field')
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: classes('section-field-label')
            }, t(field.label), ":"), /*#__PURE__*/_react["default"].createElement("div", {
              className: classes('section-field-value')
            }, values && _this2.renderValue(values, field)));
          }));
        }));
      })));
    }
  }]);
}(_react["default"].Component);
KYCConfirmLevelModal.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func.isRequired,
  onConfirm: _propTypes["default"].func.isRequired,
  level: _propTypes["default"].shape(_kycConfigShapePropTypes.kycConfigLevelShape),
  processing: _propTypes["default"].bool
};
KYCConfirmLevelModal.defaultProps = {
  processing: false
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("kyc")(KYCConfirmLevelModal);